// frontend/src/utils/axios.js
import axios from "axios";

const api = axios.create({
  baseURL: "https://api.campaigniq.ext.lionreachlabs.cloud/api",
  withCredentials: true,
});

// Global response interceptor
api.interceptors.response.use(
  response => response,
  error => {
    if (
      error.response?.status === 401 &&
      !window.location.pathname.includes("/login") &&
      !window.location.pathname.includes("/otp")
    ) {
      localStorage.removeItem("user");
    }
    return Promise.reject(error);
  }
);

export default api;
